import React from 'react'
import { ReusableTable } from 'components/Tables/ReusableTable'
import ResumenRow from './ResumenRow'
import { AddNewLine } from './AddNewLine'
import { useResumenTables } from 'context/ResumenTablesContext'

const ResumenTables = () => {
  const {
    tables = [],
    formatNumber,
    numeroDivision,
    modulos,
    totalMo,
    handleBlur,
    handleRemoveRow,
  } = useResumenTables()

  if (!tables.length) return null

  return (
    <>
      {tables.map((table, tIdx) => (
        <ReusableTable
          key={tIdx}
          className="my-table"
          dataHeader={[
            table.title,
            formatNumber(table.total),
            `${formatNumber(table.total / (numeroDivision || 1))} €/m²`,
            '',
            '',
          ]}
        >
          {table.data.map((item, idx) => (
            <ResumenRow
              key={idx}
              item={item}
              index={idx}
              data={table.data}
              setData={table.setData}
              isConstruccion={!!table.isConstruccion}
              modulos={modulos}
              totalMo={totalMo}
              numeroDivision={numeroDivision}
              totalSum={table.total}
              handleBlur={handleBlur}
              formatNumber={formatNumber}
              handleRemoveRow={handleRemoveRow}
            />
          ))}
          <AddNewLine table={table} />
          <br />
        </ReusableTable>
      ))}
    </>
  )
}

export default ResumenTables
